<template>
  <menu
    class="menu"
    :class="`menu--${ overlap }`"
  >
    <burger :overlap="overlap"/>
    <nav class="menu-nav">
      <ul class="menu-nav__links">
        <li class="menu-nav__link">
          <span class="dot">.</span>
          <a
            class="logo-link"
            @click.prevent="$emit('scrollToTop')"
          >
            <logo-mini/>
          </a>
        </li>
        <li class="menu-nav__link" :class="{ 'menu-nav__link--is-active': isActive('projects') }">
          <span class="dot">.</span><a @click="$emit('click', 'projects')">projekty</a>
        </li>
        <li class="menu-nav__link" :class="{ 'menu-nav__link--is-active': isActive('about') }">
          <span class="dot">.</span><a @click="$emit('click', 'about')">my</a>
        </li>
        <li class="menu-nav__link" :class="{ 'menu-nav__link--is-active': isActive('manifest') }">
          <span class="dot">.</span><a @click="$emit('click', 'manifest')">love</a>
        </li>
        <li class="menu-nav__link" :class="{ 'menu-nav__link--is-active': isActive('contact') }">
          <span class="dot">.</span><a @click="$emit('click', 'contact')">kontakt</a>
        </li>
        <li class="menu-nav__link"><span class="dot">.</span>
          <a
            :href="work"
            target="_blank"
          >
            kariera
          </a>
        </li>
      </ul>
    </nav>
  </menu>
</template>

<script>
import LogoMini from '@/components/LogoMini'
import Burger from '@/components/Burger'
import FooterContact from '@/components/FooterContact'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    LogoMini,
    Burger,
    FooterContact
  },
  props: {
    overlap: {
      type: String,
      default: 'hero'
    },
    active: {
      type: String,
      default: 'hero'
    }
  },
  computed: {
    ...mapState({
      work: state => state.work.file
    }),
    isActive () {
      return section => this.active === section
    }
  },
  mounted () {
    this.fetchWork()
  },
  methods: {
    ...mapActions(['fetchWork'])
  }
}
</script>

<style lang="scss" scoped>
  .menu {
    position: fixed;
    right: 0;
    z-index: 5;
    padding: 0;
    margin: 0;

    backface-visibility: hidden;

    @include media-up(lg) {
      transform-origin: left top;
      transform: translateX(100%) rotate(90deg);
    }
    @include page-offset(margin-top);
    @include media-up(xl) {
      right: calc( (100% - #{$grid-container-width}) / 2 );
    }
  }
  .menu-burger {
    @include hide-up(lg);
  }
  .menu-nav {
    position: relative;
    display: flex;
    align-items: center;

    @each $breakpoint-name, $space in $grid-space-around {
      @include media-up($breakpoint-name) {
        height: $space;
      }
    }

    @include media-down(lg) {
      transform: none;
      position: fixed;
      background: #000;
      top: 0;
      left: 100%;
      height: 100%;
      width: 100%;

      .active-menu & {
        left: 0;
      }
    }

    .active-menu & {
      a {
        color: #fff!important;
      }

      svg {
        fill: #fff !important;
      }
    }
  }
  .menu-nav__links {
    display: flex;
    @include reset-list;

    @include media-down(lg) {
      flex-direction: column;
      margin: 0 map-get($grid-space-around, xs) 70px;
      width: calc(100% - #{map-get($grid-space-around, xs)*2} );
    }

    .menu-nav__link--is-active {
      text-shadow: 1px 0 0 currentColor;

      @include media-down(lg) {
        a::before {
          content: '.';
          position: relative;
          bottom: 10px;
        }
      }
    }

    li {
      margin-right: 2em;
      @include font-white;
      display: flex;
      align-items: baseline;
      cursor: pointer;
      transition: color .15s;
      overflow: hidden;

      @include media-down(lg) {
        justify-content: flex-end;
        margin-right: 0;
      }

      @media (min-width: 1170px) and (max-height: 700px) {
        margin-right: 1.2em;
      }
    }
    a {
      @include font-white;
      text-decoration: none;
      font-size: $font-regular-bigger;
      font-family: $font-default-light;
      transition: text-shadow .25s,
                  color .15s;

      &:hover {
        text-shadow: 1px 0 0 currentColor;
      }
      @include media-down(lg) {
        @include font-style-big;

        opacity: 0;
        transform: translate3d(0, 100%, 0);
        display: inline-block;
        transition: opacity .5s ease .1s,
                    transform .4s ease .1s;

        .active-menu & {
          opacity: 1;
          transform: translate3d(0, 0, 0);
        }

        &:not(.logo-link) {
          @include font-cut;
        }
        &.logo-link {
          margin-bottom: .2em;
          line-height: 1;
        }
        &:hover {
          text-shadow: none;
        }
      }
    }
    .dot {
      @include hide-down(lg);
    }
    svg {
      height: $logo-mini-width;
      fill: #fff;
      transition: fill .15s;

      @include media-down(lg) {
        height: $logo-mini-mobile-menu-width;
      }
    }
  }

  .menu .footer-wrap {
    display: none;
    position: fixed;
    bottom: 0;
    left: 0;
    color: #fff;
    margin: 0 map-get($grid-space-around, xs) map-get($grid-space-around, xs)/2 map-get($grid-space-around, xs);
    width: calc(100% - #{map-get($grid-space-around, xs)*2} );
    font-size: 7px;
    letter-spacing: 2px;

    .active-menu & {
      display: flex;
    }
  }

  .menu {
    &--projects a,
    &--manifest a,
    &--contact a,
    &--projects .menu-nav__links li,
    &--manifest .menu-nav__links li,
    &--contact .menu-nav__links li {
      color: #000;
    }

    &--projects svg,
    &--manifest svg,
    &--contact svg {
      fill: #000;
    }
  }

  .logo-link {
    outline: none;
    transition: opacity .15s;

    &:hover,
    &:focus {
      opacity: .9;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue